export const PaymentProviders = {
  STRIPE: 'stripe_connect',
  SQUARE: 'square_connect',
  CLOVER: 'clover',
  COMMERCE_HUB: 'commerce_hub'
};
